import { render } from "./BatteryHistoryView.vue?vue&type=template&id=992df178&scoped=true"
import script from "./BatteryHistoryView.vue?vue&type=script&lang=js"
export * from "./BatteryHistoryView.vue?vue&type=script&lang=js"

import "./BatteryHistoryView.vue?vue&type=style&index=0&id=992df178&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-992df178"]])

export default __exports__